import { useEffect } from 'react';
import Venues from './pages/Venues';
import Hosts from './pages/Hosts';

// One build serves two subdomains. The hostname picks the page; on localhost
// and the pages.dev preview the first path segment does (/venues, /hosts).
export type Page = 'venues' | 'hosts';

export function pickPage(hostname: string, pathname: string): Page {
  const host = hostname.toLowerCase();
  if (host.startsWith('hosts.') || host.startsWith('cohost.')) return 'hosts';
  if (host.startsWith('venues.')) return 'venues';
  const seg = pathname.split('/')[1]?.toLowerCase();
  if (seg === 'hosts' || seg === 'cohost') return 'hosts';
  return 'venues';
}

const TITLES: Record<Page, string> = {
  venues: 'Host a group night - Outclose',
  hosts: 'Co-host an Outclose Group',
};

export default function App() {
  const page = pickPage(window.location.hostname, window.location.pathname);
  useEffect(() => { document.title = TITLES[page]; }, [page]);
  return page === 'hosts' ? <Hosts /> : <Venues />;
}
